import React from "react";
import "./CheckableButton.css";

// component usable as either a checkbox or radio button
// radio button is default, pass through checkbox prop to use as checkbox

function SuperAnnButton({
  className,
  checkbox,
  toggle,
  title,
  children,
  noBorder,
  disabled,
  superAnnButton,
  ...props
}) {
  let checkClass;
  if (checkbox) {
    checkClass = " check-box";
  } else if (toggle) {
    checkClass = " check-toggle";
  } else checkClass = " check-circle";

  return (
    <label
      className={
        "checkable-outer" + (className ? " " + className : " superAnnButton")
        // (noBorder ? "" : " checkable-border")
        // (disabled ? " checkable-disabled" : "") +
        // (children ? "" : " checkable-no-label")
      }
    >
      <input
        {...props}
        type={checkbox || toggle ? "checkbox" : "radio"}
        children={null}
        className="checkable-input"
        title={title || children}
        disabled={disabled}
      />
      <span className={toggle ? "check-toggle-label" : "checkable-label"}>
        {children}
      </span>
      <span className={"check-marker" + checkClass}></span>
    </label>
  );
}

export default SuperAnnButton;
